<template>
    <main-content>
        <div class="bg-white border rounded p-4">
            <form id="password_form">
                <div class="row">
                    <div class="col-12 mt-2 mb-4">
                        <span class="h5" v-text="$t('label.set_access_password_for_settlement_and_transfer')"></span>
                    </div>
                    <div v-if="show_sms_verify"
                         class="col-12 col-md-6 my-3"
                    >
                        <label for="sms_verify"
                               v-text="$t('label.sms_verify')"
                        ></label>
                        <input name="sms_verify"
                               type="text"
                               id="sms_verify"
                               class="form-control"
                               v-model="form_data.sms_verify"
                        >
                    </div>
                    <div v-else
                         class="col-12 col-md-6 my-3"
                    >
                        <label for="old_password"
                               v-text="$t('label.old_password')"
                        ></label>
                        <div class="row">
                            <div class="col-1">
                                <button class="form-control"
                                        style="width: fit-content"
                                        type="button"
                                        @click="togglePassword('old_password')"
                                >
                                    <i class="fas fa-eye"></i>
                                </button>
                            </div>
                            <div class="col-11">
                                <input name="old_password"
                                       :type="old_password_type"
                                       id="old_password"
                                       class="form-control"
                                       v-model="form_data.old_password"
                                >
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-6 my-3">
                        <label for="new_password"
                               v-text="$t('label.new_password_for_wallet')"
                        ></label>
                        <div class="row">
                            <div class="col-1">
                                <button class="form-control"
                                        style="width: fit-content"
                                        type="button"
                                        @click="togglePassword('new_password')"
                                >
                                    <i class="fas fa-eye"></i>
                                </button>
                            </div>
                            <div class="col-11">
                                <input name="new_password"
                                       :type="new_password_type"
                                       id="new_password"
                                       class="form-control"
                                       v-model="form_data.new_password"
                                >
                            </div>
                        </div>
                    </div>
                    <div class="col-12 mt-4">
                        <button type="button"
                                class="btn btn-success mx-2"
                                @click="changePassword()"
                                v-text="$t('btn.submit_changes')"
                        ></button>
                        <button type="button"
                                class="btn btn-primary mx-2"
                                @click="forgetPassword()"
                                v-text="$t('label.forget_wallet_old_password')"
                        ></button>
                    </div>
                </div>
            </form>
        </div>
        <div class="my-2" id="sign_key_form">
            <div class="row">
                <div class="col-12 col-md-4 my-2">
                    <div class="col-12 bg-white border rounded p-4 h-100">
                        <div class="mt-2 mb-4">
                            <span class="h5" v-text="$t('label.wallet_sign_key')"></span>
                        </div>
                        <div class="my-3">
                            <textarea
                                name="sign_key"
                                type="text"
                                id="sign_key"
                                dir="ltr"
                                class="form-control"
                                :value="sign_key"
                                disabled
                                rows="5"
                            >
                            </textarea>
                        </div>
                        <div class="mt-4">
                            <button type="button"
                                    class="btn btn-success mx-2"
                                    @click="regenerateSignKey()"
                                    v-text="$t('label.regenerate_sign_key')"
                            ></button>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-4 my-2">
                    <div class="col-12 bg-white border rounded p-4 h-100">
                        <div class="mt-2 mb-4">
                            <span class="h5" v-text="$t('label.api_key')"></span>
                        </div>
                        <div class="my-3" v-if="api_key == null">
                            <div class="col-12 my-3">
                                <span v-text="$t('label.api_key_has_been_expired')"></span>
                            </div>
                            <div class="col-12 mt-4">
                                <button type="button"
                                        class="btn btn-success mx-2"
                                        @click="regenerateApiKey()"
                                        v-text="$t('label.regenerate_api_key')"
                                ></button>
                            </div>
                        </div>
                        <div class="my-3" v-else>
                            <textarea
                                    name="api_key"
                                    type="text"
                                    id="api_key"
                                    dir="ltr"
                                    class="form-control"
                                    :value="api_key"
                                    disabled
                                    rows="5"
                            >
                            </textarea>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-4 my-2">
                    <div class="col-12 bg-white border rounded p-4 h-100">
                        <div class="mt-2 mb-4">
                            <span class="h5" v-text="$t('label.refresh_token')"></span>
                        </div>
                        <div class="my-3">
                            <textarea
                                    name="refresh_token"
                                    type="text"
                                    id="refresh_token"
                                    dir="ltr"
                                    class="form-control"
                                    :value="refresh_token"
                                    disabled
                                    rows="5"
                            >
                            </textarea>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-4 my-2">
                    <div class="col-12 bg-white border rounded p-4 h-100">
                        <div class="mt-2 mb-4">
                            <span class="h5" v-text="$t('label.inquiry_key')"></span>
                        </div>
                        <div class="my-3" v-if="inquiry_key == null">
                            <div class="col-12 my-3">
                                <span v-text="$t('label.inquiry_key_has_been_expired')"></span>
                            </div>
                            <div class="col-12 mt-4">
                                <button type="button"
                                        class="btn btn-success mx-2"
                                        @click="regenerateInquiryKey()"
                                        v-text="$t('label.regenerate_inquiry_key')"
                                ></button>
                            </div>
                        </div>
                        <div class="my-3" v-else>
                            <textarea
                                name="inquiry_key"
                                type="text"
                                id="inquiry_key"
                                dir="ltr"
                                class="form-control"
                                :value="inquiry_key"
                                disabled
                                rows="5"
                            >
                            </textarea>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-4 my-2">
                    <div class="col-12 bg-white border rounded p-4 h-100">
                        <div class="mt-2 mb-4">
                            <span class="h5" v-text="$t('label.refresh_inquiry_key')"></span>
                        </div>
                        <div class="my-3">
                            <textarea
                                name="refresh_inquiry_key"
                                type="text"
                                id="refresh_inquiry_key"
                                dir="ltr"
                                class="form-control"
                                :value="refresh_inquiry_key"
                                disabled
                                rows="5"
                            >
                            </textarea>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <p style="color: red">
           {{$t('label.inquiry_key_description')}}
        </p>

        <!--        settlement setting start -->
        <form class="my-2 bg-white rounded border p-4" id="settlement_setting">
            <div class="row align-items-baseline">
                <div class="col-12 my-2">
                    <div class="h5" v-text="$t('label.settlement_setting')"></div>
                </div>
                <div class="col-12 col-md-6 my-2" v-show="false">
                    <div class="form-group">

                        <label class="switch">
                            <input
                                type="checkbox"
                                id="settlement_with_paya_when_bank_disable"
                                v-model="settlement_with_paya_when_bank_disable"
                            />
                            <span class="slider round"></span>
                        </label>
                        <label class="m-0 p-0 ml-1 form-check-label pr-4" for="settlement_with_paya_when_bank_disable"
                               v-text="$t('wallets.label.settlement_with_paya_when_bank_disable')"></label>
                    </div>

                </div>
                <div class="col-12 col-md-6 my-2">
                    <div class="form-group">

                        <label class="switch">
                            <input
                                type="checkbox"
                                id="settlement_two_factor_setting"
                                v-model="settlement_two_factor_setting"
                            />
                            <span class="slider round"></span>
                        </label>
                        <label class="m-0 p-0 ml-1 form-check-label pr-4" for="settlement_two_factor_setting"
                               v-text="$t('wallets.label.settlement_two_factor')"></label>
                    </div>

                </div>
                <div class="col-12 mt-4">
                    <button class="btn btn-success" @click="settlementSettingAction()" :disabled="settlement_setting_loading" type="button">
                        <span>{{$t('btn.submit_changes')}}</span>
                        <span v-if="settlement_setting_loading" class="spinner-border spinner-border-sm p-2 mr-1"></span>
                    </button>
                </div>
            </div>
        </form>
        <!--        settlement setting end -->

        <form class="my-2 bg-white rounded border p-4" id="edit_data_form">
            <div class="row align-items-baseline">
                <div class="col-12 my-2">
                    <div class="h5" v-text="$t('label.edit_wallet_data')"></div>
                </div>
                <div class="col-12 col-md-6 my-2">
                    <label for="wallet_title" v-text="$t('wallets.label.wallet_title')"></label>
                    <input class="form-control" id="wallet_title" name="wallet_title" v-model="edit_form_data.wallet_title">
                </div>
                <div class="col-12 col-md-6 my-2">
                    <label for="password"
                           v-text="$t('label.current_wallet_password')"
                    ></label>
                    <div class="row">
                        <div class="col-1">
                            <button class="form-control"
                                    style="width: fit-content"
                                    type="button"
                                    @click="togglePassword('edit_form')"
                            >
                                <i class="fas fa-eye"></i>
                            </button>
                        </div>
                        <div class="col-11">
                            <input name="password"
                                   :type="password_type_edit_form"
                                   id="password"
                                   class="form-control"
                                   v-model="edit_form_data.password"
                            >
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-6 my-2">
                    <label>
                        <span v-text="$t('label.access_ips_for_webservice')"></span>
                        <span v-text="$t('label.optional_input')" class="mx-1"></span>
                    </label>
                    <button type="button"
                            class="btn btn-primary pl-2 pr-0 py-1 my-0 mx-1"
                            @click="addIp"
                            v-if="edit_form_data.access_ips.length < 10"
                    >
                        <i class="fas fa-plus"></i>
                    </button>
                    <button type="button"
                            class="btn btn-danger pl-2 pr-0 py-1 my-0 mx-1"
                            @click="removeIp"
                            v-if="edit_form_data.access_ips.length > 1"
                    >
                        <i class="fas fa-minus"></i>
                    </button>
                    <div v-for="(access_ip, index) in edit_form_data.access_ips"
                         :key="index"
                         class="mb-2"
                    >
                        <input :id="`access_ips.${index}`"
                               :name="`access_ips.${index}`"
                               class="form-control"
                               dir="ltr"
                               v-model="edit_form_data.access_ips[index]"
                        >
                    </div>
                </div>
                <div class="col-12 mt-4">
                    <button class="btn btn-success" @click="updateWallet()" type="button" v-text="$t('btn.submit_changes')"></button>
                </div>
            </div>
        </form>
    </main-content>
</template>

<script>
import mainContent from "@/components/main-content";
import $ from "jquery";
import {authService, walletService} from "@/common/api.service";
import {i18n} from "@/plugins/i18n";

export default {
        components: {mainContent},
        data() {
            return {
                settlement_two_factor_setting: false,
                settlement_with_paya_when_bank_disable:'',
                settlement_setting_loading: false,
                show_sms_verify: false,
                old_password_type: 'password',
                new_password_type: 'password',
                password_type_edit_form: 'password',
                form_data: {
                    old_password: '',
                    new_password: '',
                    sms_verify: null,
                },
                edit_form_data: {
                    wallet_title: '',
                    access_ips: [''],
                    password: '',
                },
                api_key: '',
                sign_key: '',
                refresh_token: '',
                inquiry_key: '',
                refresh_inquiry_key: '',
            };
        },
        mounted() {
            walletService.getApiKey(this.$route.params.hashid).then(res => {
                this.api_key = res.data.data.api_key;
                this.sign_key = res.data.data.sign_key;
                this.refresh_token = res.data.data.refresh_token;
                this.edit_form_data.wallet_title = res.data.data.wallet_title;
                this.edit_form_data.access_ips = res.data.data.access_ips;
                this.settlement_with_paya_when_bank_disable = res.data.data.settlement_settings.settlement_with_paya_when_bank_disable;
                this.settlement_two_factor_setting = res.data.data.settlement_settings.settlement_two_factor_setting;
                this.inquiry_key = res.data.data.inquiry_key;
                this.refresh_inquiry_key = res.data.data.refresh_inquiry_key;
            });
        },
        methods: {
            settlementSettingAction() {

                let param = {
                    settlement_with_paya_when_bank_disable: this.settlement_with_paya_when_bank_disable,
                    settlement_two_factor_setting: this.settlement_two_factor_setting,
                };

                this.settlement_setting_loading = true;

                walletService.setSettlementSetting(this.$route.params.hashid, param).then(({data}) => {
                    this.toastr.success(data.message);
                }).catch(({response}) => {
                    console.log(response)
                    this.toastr.error(response.data.message);
                    this.showMsg($('#settlement_setting'), response.data.message)
                }).finally(() => {
                    this.settlement_setting_loading = false;
                })


            },
            addIp() {
                if (this.edit_form_data.access_ips.length < 10) {
                    this.edit_form_data.access_ips.push('');
                }
            },
            removeIp() {
                this.edit_form_data.access_ips.pop();
            },
            updateWallet() {
                let form = $('#edit_data_form');

                form.validate({
                    rules: {
                        wallet_title: {
                            required: true,
                        },
                        password: {
                            required: true,
                        },
                    },
                });

                if (! form.valid()) {
                    return;
                }

                let params = {
                    access_ips: this.edit_form_data.access_ips,
                    wallet_title: this.edit_form_data.wallet_title,
                    password: this.edit_form_data.password,
                };

                walletService.editWalletData(params, this.$route.params.hashid).then(res => {
                    this.showMsg(form, 'success', i18n.t('label.data_successfully_changed'));
                }).catch(({response}) => {
                    this.showMsg(form, 'danger', response.data.message);
                });
            },
            regenerateApiKey() {
                let form = $('#sign_key_form');

                walletService.regenerateApiKey(this.$route.params.hashid).then(res => {
                    this.showMsg(form, 'success', res.data.message);

                    this.api_key = res.data.data.api_key;
                });
            },
            regenerateInquiryKey() {
                let form = $('#sign_key_form');

                walletService.regenerateInquiryKey(this.$route.params.hashid).then(res => {
                    this.showMsg(form, 'success', res.data.message);

                    this.inquiry_key = res.data.data.inquiry_key;
                });
            },
            regenerateSignKey() {
                let form = $('#sign_key_form');

                walletService.generateNewSignKey(this.$route.params.hashid).then(res => {
                    this.showMsg(form, 'success', res.data.message);
                    this.sign_key = res.data.data.sign_key;
                });
            },
            togglePassword(value) {
                if (value === 'old_password') {
                    this.old_password_type = this.old_password_type === 'password' ? 'text' : 'password';
                }

                if (value === 'new_password') {
                    this.new_password_type = this.new_password_type === 'password' ? 'text' : 'password';
                }

                if (value === 'edit_form') {
                    this.password_type_edit_form = this.password_type_edit_form === 'password' ? 'text' : 'password';
                }
            },
            forgetPassword() {
                let form = $('#password_form');
                let phone = this.$store.state.user.current_user.phone;
            
                let verify = {
                    phone,
                };
            
                authService.sendVerifyWallet(verify).then(res => {
                    this.show_sms_verify = true;
                    this.showMsg(form, 'success', res.data.message);
                }).catch(error => {
                    // Handle any error that may occur during verification sending
                    this.showMsg(form, 'danger', error.response.data.message || 'Something went wrong.');
                });
            },
            changePassword() {
                let form = $('#password_form');

                form.validate({
                    rules: {
                        new_password: {
                            required: true,
                        },
                    },
                });

                if (! form.valid()) {
                    return;
                }

                let params = {
                    old_password: this.form_data.old_password,
                    new_password: this.form_data.new_password,
                    wallet_hashid: this.$route.params.hashid,
                    sms_verify: this.form_data.sms_verify,
                };

                walletService.changePassword(params).then(res => {
                    this.$router.push('/wallets');
                }).catch(({response}) => {
                    if (response.data.data) {
                        let message = '';

                        for (let [key, value] of Object.entries(response.data.data)) {
                            for (let error of value) {
                                message += error;
                                message += '<br>';
                            }
                        }

                        this.showMsg(form, 'danger', message);
                    } else {
                        this.showMsg(form, 'danger', response.data.message);
                    }
                });
            },
        },
    }
</script>
<style scoped>
.switch-div {
    width: fit-content;
    padding: 8px 27px;
    background: #fff;
    box-shadow: 0 0 7px 0 #9c9c9c5e;
}

.switch {
    position: relative;
    display: inline-block;
    width: 32px;
    height: 18px;
}

/* Hide default HTML checkbox */
.switch input {
    opacity: 0;
    width: 0;
    height: 0;
}

/* The slider */
.slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #343433;
    -webkit-transition: .4s;
    transition: .4s;
}

.slider:before {
    position: absolute;
    content: "";
    height: 15px;
    width: 15px;
    left: 3px;
    bottom: 1.5px;
    background-color: white;
    -webkit-transition: .4s;
    transition: .4s;
}

input:checked + .slider {
    background-color: #2196F3;
}

input:focus + .slider {
    box-shadow: 0 0 1px #2196F3;
}

input:checked + .slider:before {
    -webkit-transform: translateX(10px);
    -ms-transform: translateX(10px);
    transform: translateX(10px);
}

.slider.round {
    border-radius: 25px;
}

.slider.round:before {
    border-radius: 25px;
}

.info-icon {
    cursor: pointer;
    color: #0f9af0;
    display: inline-block;
}
</style>